import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core-services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ResetPasswordVM } from 'src/app/models/Registration';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  submitted: boolean = false;
  confirmPassNotSame: boolean = false;
  stateParams: any;
  IsUserValid: boolean = false;
  constructor(private fb: FormBuilder, private authenticationService: AuthService,
    private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router) {

    this.resetForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$')]],
      confirmPassword: ['', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$')]]
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.stateParams = params;
    });
  }

  public hasError = (controlName: string, errorName: string) => {
    return this.resetForm.controls[controlName].hasError(errorName);
  }
  ngOnInit() {

    this.checkValidUserResetPassword();
  }

  checkValidUserResetPassword() {
    let model = new ResetPasswordVM();
    model.userId = this.stateParams != null ? this.stateParams.userid : "";
    model.token = this.stateParams != null ? this.stateParams.token : "";
    this.authenticationService.checkValidUserResetPassword(model).subscribe((response: any) => {
      if (response != null && response.isSuccess) {
        this.IsUserValid = true;
      }
      else {
        this.IsUserValid = false;
        this.toastr.error(response.message, 'Error');
      }
    });
  }

  checkPasswords() {
    let pass = this.resetForm.controls.newPassword.value;
    let confirmPass = this.resetForm.controls.confirmPassword.value;
    if (pass != null && pass != "" && confirmPass != null && confirmPass != "") {
      if (pass === confirmPass) {
        this.confirmPassNotSame = false;
      }
      else {
        this.confirmPassNotSame = true;
      }
    }
    else {
      this.confirmPassNotSame = false;
    }
  }

  resetPassword() {
    this.submitted = true;
    if (this.resetForm.invalid) {
      return;
    }
    else {
      let model = new ResetPasswordVM();
      model = this.resetForm.value;
      model.userId = this.stateParams != null ? this.stateParams.userid : "";
      model.token = this.stateParams != null ? this.stateParams.token : "";
      this.authenticationService.resetPassword(model).subscribe((response: any) => {
        if (response != null && response.isSuccess) {
          this.IsUserValid = true;
          this.router.navigate(['login']);
          this.toastr.success(response.message, 'Success');
        }
        else {
          this.IsUserValid = false;
          this.toastr.error(response.message, 'Error');
        }
      })
    }

  }

}
